import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext({ appName: "Fazenda Digital", logoUrl: null });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({ app_name: "Fazenda Digital", logo_url: null });

  useEffect(() => {
    api.get("/settings").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);

  return (
    <SettingsContext.Provider value={{ appName: settings.app_name, logoUrl: settings.logo_url, whatsapp: settings.whatsapp_empresa, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
